export type LaunchPadImpactStats = {
  time_saved: {
    total_seconds: number;
    display: string;
  };
  constituent_questions_answered: number;
};

export async function fetchLaunchPadImpactStats(
  municipalityId?: number,
): Promise<LaunchPadImpactStats> {
  const url = new URL("/api/v1/launch_pad/impact_stats", window.location.origin);
  if (municipalityId) {
    url.searchParams.set("municipality_id", String(municipalityId));
  }

  const response = await fetch(url.toString(), {
    headers: { Accept: "application/json" },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Failed to load impact stats (${response.status})`);
  }

  return response.json();
}
